import { render, staticRenderFns } from "./AdvertisementDetailComponent.vue?vue&type=template&id=15164666&scoped=true&"
import script from "./AdvertisementDetailComponent.vue?vue&type=script&lang=js&"
export * from "./AdvertisementDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15164666",
  null
  
)

export default component.exports